// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.demo-join {
  --demo-bg: #070a12;
  --demo-card: rgba(255, 255, 255, 0.06);
  --demo-line: rgba(255, 255, 255, 0.1);
  --demo-text: #f4f7fb;
  --demo-muted: rgba(226, 232, 240, 0.72);
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  background: var(--demo-bg);
  color: var(--demo-text);
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Text", Inter, Roboto, sans-serif;
  position: relative;
  overflow-x: hidden;
  padding:
    max(12px, env(safe-area-inset-top))
    max(20px, env(safe-area-inset-right))
    max(16px, env(safe-area-inset-bottom))
    max(20px, env(safe-area-inset-left));
}

.demo-join__glow {
  pointer-events: none;
  position: absolute;
  inset: -20% -10% auto;
  height: 52%;
  background:
    radial-gradient(ellipse at 50% 0%, color-mix(in srgb, var(--demo-accent) 28%, transparent) 0%, transparent 62%),
    radial-gradient(circle at 80% 20%, rgba(56, 189, 248, 0.16), transparent 42%);
}

.demo-join__top {
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: flex-end;
}

.demo-join__main {
  position: relative;
  z-index: 1;
  flex: 1 1;
  width: 100%;
  max-width: 28rem;
  margin: 1.25rem auto 0;
}

.demo-join__kicker {
  margin: 0 0 0.4rem;
  font-size: 0.72rem;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: color-mix(in srgb, var(--demo-accent) 82%, white);
  font-weight: 700;
}

.demo-join__title {
  margin: 0 0 0.65rem;
  font-size: clamp(1.7rem, 6vw, 2.15rem);
  line-height: 1.15;
  letter-spacing: -0.03em;
  font-weight: 720;
}

.demo-join__lead,
.demo-join__hint,
.demo-join__status,
.demo-join__legal-note {
  color: var(--demo-muted);
  line-height: 1.55;
}

.demo-join__lead {
  margin: 0 0 1.4rem;
  font-size: 1rem;
}

.demo-join__hint {
  margin: 0 0 1rem;
  padding: 0.85rem 1rem;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid var(--demo-line);
}

.demo-join__form {
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
}

.demo-join__field {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--demo-muted);
}

.demo-join__field input {
  appearance: none;
  width: 100%;
  box-sizing: border-box;
  min-height: 52px;
  border: 1px solid var(--demo-line);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.06);
  color: var(--demo-text);
  font-size: 1.05rem;
  padding: 0.85rem 1rem;
  outline: none;
  backdrop-filter: blur(18px);
}

.demo-join__field input:focus {
  border-color: color-mix(in srgb, var(--demo-accent) 70%, white);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--demo-accent) 22%, transparent);
}

.demo-join__consent {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.95rem 1rem;
  border-radius: 16px;
  border: 1px solid var(--demo-line);
  background: var(--demo-card);
  font-size: 0.92rem;
  line-height: 1.45;
  color: var(--demo-text);
  cursor: pointer;
  transition: border-color 0.22s cubic-bezier(0.16, 1, 0.3, 1), background 0.22s ease;
}

.demo-join__consent.is-on {
  border-color: color-mix(in srgb, var(--demo-accent) 65%, white);
  background: color-mix(in srgb, var(--demo-accent) 12%, rgba(255, 255, 255, 0.04));
}

.demo-join__consent input {
  width: 22px;
  height: 22px;
  margin-top: 2px;
  flex-shrink: 0;
  accent-color: var(--demo-accent);
}

.demo-join__submit,
.demo-join__continue {
  min-height: 54px;
  border: 0;
  border-radius: 16px;
  font-size: 1.05rem;
  font-weight: 700;
  cursor: pointer;
  transition: transform 0.18s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.18s ease;
}

.demo-join__submit {
  background: var(--demo-accent);
  color: #04140d;
  box-shadow: 0 10px 28px color-mix(in srgb, var(--demo-accent) 28%, transparent);
}

.demo-join__continue {
  width: 100%;
  margin-bottom: 1rem;
  background: rgba(255, 255, 255, 0.08);
  color: var(--demo-text);
  border: 1px solid var(--demo-line);
}

.demo-join__submit:active,
.demo-join__continue:active {
  transform: scale(0.98);
}

.demo-join__submit:disabled {
  opacity: 0.65;
  cursor: wait;
}

.demo-join__error {
  margin: 0;
  color: #fda4af;
  font-size: 0.92rem;
}

.demo-join__wait {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  padding: 1.1rem 1rem;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid var(--demo-line);
}

.demo-join__pulse {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: var(--demo-accent);
  box-shadow: 0 0 0 0 color-mix(in srgb, var(--demo-accent) 55%, transparent);
  animation: demo-join-pulse 1.6s ease-out infinite;
  flex-shrink: 0;
}

@keyframes demo-join-pulse {
  0% { box-shadow: 0 0 0 0 color-mix(in srgb, var(--demo-accent) 50%, transparent); }
  70% { box-shadow: 0 0 0 12px transparent; }
  100% { box-shadow: 0 0 0 0 transparent; }
}

.demo-join__footer {
  position: relative;
  z-index: 1;
  margin-top: 1.75rem;
}

.demo-join__legal-note {
  font-size: 0.82rem;
  margin-bottom: 0.6rem;
}

.demo-join__legal-note a {
  color: color-mix(in srgb, var(--demo-accent) 80%, white);
}

.demo-join .legal-footer {
  color: var(--demo-muted);
}

.demo-join .legal-footer a {
  color: inherit;
}
`, "",{"version":3,"sources":["webpack://./src/pages/public/DemoJoinPage.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,qCAAqC;EACrC,oBAAoB;EACpB,uCAAuC;EACvC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,wFAAwF;EACxF,kBAAkB;EAClB,kBAAkB;EAClB;;;;wCAIsC;AACxC;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX;;iFAE+E;AACjF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAO;EACP,WAAW;EACX,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,wDAAwD;EACxD,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;;;EAIE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;EACnB,qCAAqC;EACrC,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,+DAA+D;EAC/D,6EAA6E;AAC/E;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,kCAAkC;EAClC,4BAA4B;EAC5B,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,eAAe;EACf,mFAAmF;AACrF;;AAEA;EACE,+DAA+D;EAC/D,iFAAiF;AACnF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;EACd,gCAAgC;AAClC;;AAEA;;EAEE,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,6EAA6E;AAC/E;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,+EAA+E;AACjF;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,qCAAqC;EACrC,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,2EAA2E;EAC3E,iDAAiD;EACjD,cAAc;AAChB;;AAEA;EACE,KAAK,2EAA2E,EAAE;EAClF,MAAM,kCAAkC,EAAE;EAC1C,OAAO,+BAA+B,EAAE;AAC1C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".demo-join {\n  --demo-bg: #070a12;\n  --demo-card: rgba(255, 255, 255, 0.06);\n  --demo-line: rgba(255, 255, 255, 0.1);\n  --demo-text: #f4f7fb;\n  --demo-muted: rgba(226, 232, 240, 0.72);\n  min-height: 100dvh;\n  display: flex;\n  flex-direction: column;\n  background: var(--demo-bg);\n  color: var(--demo-text);\n  font-family: -apple-system, BlinkMacSystemFont, \"SF Pro Text\", Inter, Roboto, sans-serif;\n  position: relative;\n  overflow-x: hidden;\n  padding:\n    max(12px, env(safe-area-inset-top))\n    max(20px, env(safe-area-inset-right))\n    max(16px, env(safe-area-inset-bottom))\n    max(20px, env(safe-area-inset-left));\n}\n\n.demo-join__glow {\n  pointer-events: none;\n  position: absolute;\n  inset: -20% -10% auto;\n  height: 52%;\n  background:\n    radial-gradient(ellipse at 50% 0%, color-mix(in srgb, var(--demo-accent) 28%, transparent) 0%, transparent 62%),\n    radial-gradient(circle at 80% 20%, rgba(56, 189, 248, 0.16), transparent 42%);\n}\n\n.demo-join__top {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.demo-join__main {\n  position: relative;\n  z-index: 1;\n  flex: 1;\n  width: 100%;\n  max-width: 28rem;\n  margin: 1.25rem auto 0;\n}\n\n.demo-join__kicker {\n  margin: 0 0 0.4rem;\n  font-size: 0.72rem;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: color-mix(in srgb, var(--demo-accent) 82%, white);\n  font-weight: 700;\n}\n\n.demo-join__title {\n  margin: 0 0 0.65rem;\n  font-size: clamp(1.7rem, 6vw, 2.15rem);\n  line-height: 1.15;\n  letter-spacing: -0.03em;\n  font-weight: 720;\n}\n\n.demo-join__lead,\n.demo-join__hint,\n.demo-join__status,\n.demo-join__legal-note {\n  color: var(--demo-muted);\n  line-height: 1.55;\n}\n\n.demo-join__lead {\n  margin: 0 0 1.4rem;\n  font-size: 1rem;\n}\n\n.demo-join__hint {\n  margin: 0 0 1rem;\n  padding: 0.85rem 1rem;\n  border-radius: 14px;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid var(--demo-line);\n}\n\n.demo-join__form {\n  display: flex;\n  flex-direction: column;\n  gap: 0.9rem;\n}\n\n.demo-join__field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: var(--demo-muted);\n}\n\n.demo-join__field input {\n  appearance: none;\n  width: 100%;\n  box-sizing: border-box;\n  min-height: 52px;\n  border: 1px solid var(--demo-line);\n  border-radius: 14px;\n  background: rgba(255, 255, 255, 0.06);\n  color: var(--demo-text);\n  font-size: 1.05rem;\n  padding: 0.85rem 1rem;\n  outline: none;\n  backdrop-filter: blur(18px);\n}\n\n.demo-join__field input:focus {\n  border-color: color-mix(in srgb, var(--demo-accent) 70%, white);\n  box-shadow: 0 0 0 3px color-mix(in srgb, var(--demo-accent) 22%, transparent);\n}\n\n.demo-join__consent {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  padding: 0.95rem 1rem;\n  border-radius: 16px;\n  border: 1px solid var(--demo-line);\n  background: var(--demo-card);\n  font-size: 0.92rem;\n  line-height: 1.45;\n  color: var(--demo-text);\n  cursor: pointer;\n  transition: border-color 0.22s cubic-bezier(0.16, 1, 0.3, 1), background 0.22s ease;\n}\n\n.demo-join__consent.is-on {\n  border-color: color-mix(in srgb, var(--demo-accent) 65%, white);\n  background: color-mix(in srgb, var(--demo-accent) 12%, rgba(255, 255, 255, 0.04));\n}\n\n.demo-join__consent input {\n  width: 22px;\n  height: 22px;\n  margin-top: 2px;\n  flex-shrink: 0;\n  accent-color: var(--demo-accent);\n}\n\n.demo-join__submit,\n.demo-join__continue {\n  min-height: 54px;\n  border: 0;\n  border-radius: 16px;\n  font-size: 1.05rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: transform 0.18s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.18s ease;\n}\n\n.demo-join__submit {\n  background: var(--demo-accent);\n  color: #04140d;\n  box-shadow: 0 10px 28px color-mix(in srgb, var(--demo-accent) 28%, transparent);\n}\n\n.demo-join__continue {\n  width: 100%;\n  margin-bottom: 1rem;\n  background: rgba(255, 255, 255, 0.08);\n  color: var(--demo-text);\n  border: 1px solid var(--demo-line);\n}\n\n.demo-join__submit:active,\n.demo-join__continue:active {\n  transform: scale(0.98);\n}\n\n.demo-join__submit:disabled {\n  opacity: 0.65;\n  cursor: wait;\n}\n\n.demo-join__error {\n  margin: 0;\n  color: #fda4af;\n  font-size: 0.92rem;\n}\n\n.demo-join__wait {\n  display: flex;\n  align-items: center;\n  gap: 0.85rem;\n  padding: 1.1rem 1rem;\n  border-radius: 16px;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid var(--demo-line);\n}\n\n.demo-join__pulse {\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  background: var(--demo-accent);\n  box-shadow: 0 0 0 0 color-mix(in srgb, var(--demo-accent) 55%, transparent);\n  animation: demo-join-pulse 1.6s ease-out infinite;\n  flex-shrink: 0;\n}\n\n@keyframes demo-join-pulse {\n  0% { box-shadow: 0 0 0 0 color-mix(in srgb, var(--demo-accent) 50%, transparent); }\n  70% { box-shadow: 0 0 0 12px transparent; }\n  100% { box-shadow: 0 0 0 0 transparent; }\n}\n\n.demo-join__footer {\n  position: relative;\n  z-index: 1;\n  margin-top: 1.75rem;\n}\n\n.demo-join__legal-note {\n  font-size: 0.82rem;\n  margin-bottom: 0.6rem;\n}\n\n.demo-join__legal-note a {\n  color: color-mix(in srgb, var(--demo-accent) 80%, white);\n}\n\n.demo-join .legal-footer {\n  color: var(--demo-muted);\n}\n\n.demo-join .legal-footer a {\n  color: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
